import React, { useState } from 'react';
import { setSesion } from './apiAuth';

export default function Login({ onLogin }) {
  const [usuario, setUsuario] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const r = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuario, password }),
      });
      const d = await r.json();
      if (!r.ok) {
        setError(d.error || 'Error al iniciar sesión');
        return;
      }
      setSesion(d.token, d.usuario);
      onLogin(d.usuario);
    } catch (err) {
      setError('No se pudo conectar con el servidor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f3f4f6' }}>
      <form onSubmit={submit} style={{ background: 'white', padding: 40, borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,0.1)', width: 360 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ backgroundColor: '#f97316', width: 56, height: 56, borderRadius: 14, margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ color: 'white', fontWeight: 800, fontSize: 22 }}>R</span>
          </div>
          <h1 style={{ margin: 0, color: '#1a3a6e', fontSize: 24, fontWeight: 700, letterSpacing: '-0.3px' }}>Sistema de</h1>
          <div style={{ marginTop: 4, color: '#1a3a6e', fontSize: 24, fontWeight: 700, letterSpacing: '-0.3px' }}>Referidos</div>
        </div>

        {error && (
          <div style={{ backgroundColor: '#fee2e2', color: '#b91c1c', padding: '10px 12px', borderRadius: 6, marginBottom: 16, fontSize: 14 }}>
            {error}
          </div>
        )}

        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Usuario</label>
        <input
          value={usuario}
          onChange={(e) => setUsuario(e.target.value)}
          style={{ width: '100%', padding: 10, marginBottom: 16, borderRadius: 6, border: '1px solid #d1d5db', boxSizing: 'border-box' }}
          autoFocus
        />

        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Contraseña</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ width: '100%', padding: 10, marginBottom: 24, borderRadius: 6, border: '1px solid #d1d5db', boxSizing: 'border-box' }}
        />

        <button
          disabled={loading}
          type="submit"
          style={{
            width: '100%', padding: 12, backgroundColor: '#f97316', color: 'white', border: 'none',
            borderRadius: 6, cursor: 'pointer', fontWeight: 'bold', fontSize: 15,
            boxShadow: '0 4px 10px rgba(249,115,22,0.35)',
          }}
        >
          {loading ? 'Ingresando…' : 'Ingresar'}
        </button>
      </form>
    </div>
  );
}
